/**
 * Client React Query partagé.
 * Les 4xx sont des erreurs métier définitives : aucun retry automatique.
 */

import { QueryClient } from '@tanstack/react-query';

import { ApiError } from './api/client';

function shouldRetry(failureCount: number, error: unknown): boolean {
  if (error instanceof ApiError) {
    if (error.status >= 400 && error.status < 500) {
      return false;
    }
    if (error.status === 0) {
      // Erreur réseau ou transport : une nouvelle tentative est pertinente.
      return failureCount < 2;
    }
  }
  return failureCount < 2;
}

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      gcTime: 5 * 60_000,
      refetchOnWindowFocus: false,
      retry: shouldRetry,
    },
    mutations: {
      retry: false,
    },
  },
});
